// src/api/portfolioApi.js
import http from './http';

const API_URL = '/api/portfolio';

export const getPortfolioItems = () => http.get(API_URL);
export const createPortfolio = (data) => http.post(API_URL, data);
export const updatePortfolio = (id, data) => http.put(`${API_URL}/${id}`, data);
export const deletePortfolio = (id) => http.delete(`${API_URL}/${id}`);

export const uploadPortfolioImage = (file) => {
  const formData = new FormData();
  formData.append('file', file);
  return http.post(`${API_URL}/upload`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
};
